export const trackingCookieNames = {
  dataDog: '_dd_s',
  utm: 'utm_source',
};

//  Name of event dispatched from GTM whenever cookie consent modified in CookieHub banner
export const COOKIE_CHOICE_MODIFIED_EVENT = 'cookieChoiceModified';
